export const SET_FAZENDAS_USUARIO = 'usuariofazenda/SET_FAZENDAS_USUARIO';
export const RESET_FAZENDAS_USUARIO = 'usuariofazenda/RESET_FAZENDAS_USUARIO';

export const setFazendasUsuario = fazendasUsuario => {
  return {
    type: SET_FAZENDAS_USUARIO,
    payload: fazendasUsuario
  };
};
